import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_hubdoinvestidor.png",
      alt: "Estratégias Hub do Investidor",
    },
    title: "Opere com o Hub do Investidor",

    // String ou array de strings
    text: "Atuando desde 2020 como casa de análise independente, nos orgulhamos de procurar soluções de investimentos inovadoras e adequadas à relação de risco x retorno do cliente.",
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Estratégia Hub Trading",
    heading: "Análise Técnica Purista + Contexto Macro",
    subtitle:
      "Nosso time de analistas atuam baseados em price action, suportes e resistências combinado com indicadores de frequência e volumes.",
  },

  cta: {
    title: "Vamos embarcar nessa jornada?",
    subtitle: "Fale com o nosso atendimento para ativar a nossa solução.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Hub do Investidor",
    col1: [
      "Nossa missão é guiar o investidor na tomada de decisão, provando que consistência e planejamento elevarão o seu sucesso nos investimentos. Para isso, oferecemos as melhores soluções financeiras de acordo com o perfil de investimento de cada cliente.",
    ],
    // col2: [
    //   "Acreditamos que investir deve ser uma opção simples e acessível para todos. Oferecemos uma gama extensa de diferentes tipos de serviços, que se adequam ao que você busca no mercado financeiro.",
    // ],
  },

  stats: {
    title: "Alguns números do Hub do Investidor",
    subtitle:
      "Na estrada desde 2020. Uma das casas de análise mais conceituadas do mercado.",
    data: [
      {
        value: "+1k",
        description: "Clientes",
      },
      {
        value: "+50m",
        description: "Sob aconselhamento direto",
      },
      {
        value: "+10",
        description: "Produtos financeiros a sua disposição",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs do Hub do Investidor?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Você não precisa se preocupar com o mercado 100% do tempo",
      },
      {
        icon: iconsSet.chat,
        title: "Time de suporte",
        description:
          "O Hub conta com um amplo time de analistas para auxiliar você com qualquer demanda",
      },
      {
        icon: iconsSet.favorite,
        title: "Respeito ao cliente",
        description: "Operamos com os pés no chão e baixo giro de operações",
      },
      {
        icon: iconsSet.balance,
        title: "Análise Técnica Purista",
        description:
          "Métodos clássicos e aplicados com disciplina e consistência",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Macro",
        description:
          "O nosso DNA veio dos livros. Contextualização macroeconômica mesmo para trades curtos",
      },
      {
        icon: iconsSet.growth,
        title: "Casa de análise",
        description: "Na pista desde 2020, credenciados pela Apimec",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Estou aprendendo ainda, já vi vários vídeos no Youtube, mas na conta da plataforma eu estava sempre perdendo, e muito. E, ainda não achei nenhum operacional bom até ver vocês operarem. Obrigado!",
      author: "César Neves",
      job: "Engenheiro civil",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Pouca perda, muito ganho, parabéns Erek! Em 2 semanas fez a meta de muitos em 3 meses! Haha",
      author: "Wanderson",
      job: "Administrador",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
